// @flow

import React from 'react';
import { colors } from '../constants';
import styled from 'styled-components';

type Props = {
  color: string,
  hoverColor: string,
  size: string,
  verticalAlign: string,
  marginRight: string,
  title: string,
};

const pencilSvg = (props: Props) => {
  const {
    size,
    hoverColor,
    verticalAlign,
    marginRight,
    title,
    color,
    ...rest
  } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <title>{title}</title>
      <path
        fill={color}
        fillRule="nonzero"
        d="M12.999 3.995L3.485 13.51l3.005 3.005L16.005 7 13 3.995zm1.042-1.043l3.007 3.007 1.215-1.215a.9.9 0 0 0 0-1.272l-1.735-1.735a.9.9 0 0 0-1.272 0l-1.215 1.215zM5.32 17.43l-2.75-2.75-.844 3.593 3.594-.843zm-5.3 1.664l1.24-5.287a.737.737 0 0 1 .197-.353L14.214.694a2.374 2.374 0 0 1 3.356 0l1.737 1.736a2.375 2.375 0 0 1-.001 3.355L6.546 18.543a.737.737 0 0 1-.352.196L.906 19.98a.737.737 0 0 1-.886-.885z"
      />
    </svg>
  );
};

// $FlowFixMe
const PencilIcon = styled(pencilSvg)`
  vertical-align: ${(props) => props.verticalAlign};
  margin-right: ${(props) => props.marginRight};
  cursor: pointer;

  &:hover {
    path {
      fill: ${(props) => props.hoverColor};
    }
  }
`;

PencilIcon.displayName = 'PencilIcon';

PencilIcon.defaultProps = {
  hoverColor: colors.darkestGrey,
  size: '20px',
  verticalAlign: 'text-bottom',
  marginRight: '0',
  title: 'edit',
  color: colors.mediumGrey,
};

export default PencilIcon;
